import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
/* eslint-disable */


const test = 'https://jcrn-api-server.eilis-ai.com/api/v1/'
const CryptoJS = require('crypto-js');

// new
var key = "XHOJaT4QqkvlsmjfuLhPlOInD9NiVCv2";
var iv = "N6lRbzhhbyHgiU68"
var keyStr = CryptoJS.enc.Utf8.parse(key)
var ivStr = CryptoJS.enc.Utf8.parse(iv)
Vue.use(Vuex);

const options = {
    iv: ivStr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
};

const state = {
  checking: false, // 是否有新增位置
  tempTwoWeeksRecord: [], // 14天記錄
  tempRecord: [], // 7天記錄
  brandColor: '', // 品牌主色
  tempCarrier: '', // 載具條碼
  brandData: null, // 品牌資料
  personalData: [], // 個人資料
  eilisProfile: [], // 註冊資料
  shopCart: [],
  config: [],
  info: {
    clientId: localStorage.getItem('channelId') ? localStorage.getItem('channelId') : '',
    token: '',
    phone: '',
    countryCode: '',
  },
}
const getters = {
  checking: state => state.checking,
  tempTwoWeeksRecord: state => state.tempTwoWeeksRecord,
  tempRecord: state => state.tempRecord,
  brandColor: state => state.brandColor,
  tempCarrier: state => state.tempCarrier,
  brandData: state => state.brandData,
  personalData: state => state.personalData,
  info: state => state.info,
  eilisProfile: state => state.eilisProfile,
  config: state => state.config,
}
const actions = {
  // 獲取使用者足跡
  getLocationRecord({ commit, store }, contents) {
    const apiUrl = `${test}getCheckInRecords`;
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: 'LINE',
      auth: contents.auth, // 品牌代碼
      shopNo: contents.shopNo,
      phone: contents.phone,
      startDate: contents.startDate,
      endDate: contents.endDate,
    });
    // 要加toString()
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 記錄使用者店家
  insertLocation({ commit, store }, contents) {
    const apiUrl = `${test}checkIn`;
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      service: contents.service,
      auth: contents.auth, // 品牌代碼
      shopNo: contents.shopNo,
      shopName: contents.shopName,
      phone: contents.phone,
      name: contents.name,
    });
    // 要加toString()
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 加密
  Encrypt({ }, contents) {
    // console.log(JSON.stringify(contents));
    let options = {
        iv: ivStr,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    };
    var encryptStr = CryptoJS.AES.encrypt(JSON.stringify(contents), keyStr, options).toString();
    // console.log(encryptStr)
    return encryptStr
  },
  // 更新會員資料
  updateInfo({ commit, store }, contents) {
    const apiUrl = `${test}updateUser`;
    const options = {
      iv: ivStr,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    };
    const content = JSON.stringify({
      clientId: contents.clientId, // 品牌代碼
      phone: contents.userPhone,
      name: contents.userName,
      birth: contents.userBirth,
      email: contents.email,
      profileImg: contents.profileImg,
      carrier: contents.carrier,
      userId: contents.userId
    });
    // 要加toString()
    const signature = CryptoJS.AES.encrypt(content, keyStr, options).toString()
    const data = {
      content: signature,
      accessToken: contents.access,
    };
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 解密
  // Decrypt({ }, contents) {
  //   // console.log(contents);
  //   let encryptedHexStr = CryptoJS.enc.Base64.parse(contents);
  //   // console.log(encryptedHexStr);
  //   let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  //   let decrypt = CryptoJS.AES.decrypt(srcs, keyStr, {
  //       iv: ivStr,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //   });
  //   let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  //   // console.log(decryptedStr)
  //   return decryptedStr
  //   // .then((res) => {
  //   //   return res
  //   // })
  // },
  // 台灣簡訊驗證
  TWtextmsg({ commit, store }, contents) {
  // const code = `${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}${Math.floor(Math.random()*(9-0+1))+0}`
  const apiUrl = `https://louisa-api-server.eilis-ai.com/sendSMS`
  const data = {
    phone: contents.phone, // 起始交易日期
    message: contents.code,
    service: contents.service,
    auth: contents.gate,
  }
  return axios.post(apiUrl, data)
    .then((res) => {
      // console.log(res);
      return res;
    });
  },
  getShops({ commit },contents) {
    const apiUrl = `${test}getShops`
    const content = {
        service: contents.service,
        auth: contents.auth
      };
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  checkAccountGetClientID({ commit },contents) {
    const apiUrl = `${test}checkAccount`
    const content = {
        service: contents.service,
        auth: contents.auth
      };
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  sendCode({ commit },contents) {
    const apiUrl = `${test}getRegConfig`
    const content = {
        code: contents.code,
      };
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  checkUserByPhone({ commit },contents) {
    const apiUrl = `${test}checkUserByPhone`
    const content = {
        phone: contents.phone,
        clientId: contents.clientId,
      };
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  checkUserByToken({ commit },contents) {
    const apiUrl = `${test}checkUserByToken`
    const content = {
        service: contents.service,
        auth: contents.auth,
        token: contents.token
      };
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  register({ commit },contents) {
    const apiUrl = `${test}register`
    const content = {
      service: contents.service,
      token: contents.token,
      auth: contents.brandID,
      clientId: contents.clientId,
      phone: contents.phone,
      name: contents.name,
      profileImg: contents.profileImg,
      birth: ''
    };
    // console.log(content);
    // return;
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
      content: signature,
      // accessToken: contents.accessToken
    }
    // console.log(signature);
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
      }
    }
    // console.log(data);
    return axios.post(apiUrl, data, config)
      .then((res) => {
          return res;
      });
  },
  // 解密
  Decrypt({ commit }, payload) {
      // console.log(payload);
      const originText = CryptoJS.AES.decrypt(payload, keyStr, options).toString(CryptoJS.enc.Utf8);
      // console.log(originText);
      return originText
      // commit('receivePage', JSON.parse(originText));
  },
  // 獲取品牌config
  getConfig({ commit, store }, contents) {
    const apiUrl = `${test}getConfig`
    const content = {
      service: contents.service,
      auth: contents.auth
    }
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
        content: signature,
        // accessToken: contents.accessToken
      }
      // console.log(signature);
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
        }
      }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
  // 快速通關
  fastClearance({ commit, store }, contents) {
    const apiUrl = `${test}fastClearance`
    const content = {
      clientId: contents.clientId,
      service: contents.service,
      auth: contents.auth,
      userId: contents.userId,
      token: contents.token,
      shopNo: contents.shopNo,
      shopName: contents.shopName
    }
    var signature = CryptoJS.AES.encrypt((JSON.stringify(content)), keyStr, options).toString()
    const data = {
        content: signature,
        // accessToken: contents.accessToken
      }
      // console.log(signature);
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'api-key': '175e0506314052a7d2a45ae20f6b0d257720b5f5',
        }
      }
    return axios.post(apiUrl, data, config)
      .then((res) => {
        return res;
      });
  },
}
const mutations = {
  storepersonal(state, { personal }) {
    // console.log(Efile);
    state.personalData = personal
  },
  storeEilisFile(state, { Efile }) {
    // console.log(Efile);
    state.eilisProfile = Efile
  },
  updateCountryCode (state, { code }) {
    state.info.countryCode = code
  },
  updatephone (state, { phone }) {
    state.info.phone = phone
  },
  updateBrandData(state, { brand }) {
    // console.log(brand);
    state.brandData = brand
  },
  updateRecord(state, { record }) {
    // console.log(record);
    state.tempRecord = record
  },
  updateTwoRecord(state, { record }) {
    // console.log(record);
    state.tempTwoWeeksRecord = record
  },
  updateCheckingStatus(state, { status }) {
    // console.log(status);
  state.checking = status
  }
}
export default {
    state,
    getters,
    actions,
    mutations
}